'use client';

import { listingModule } from './ListingEngine';
import { SearchPageLayout } from './SearchPageLayout';

export const ListingPage = () => (
  <SearchPageLayout
    engineModule={listingModule}
    resultSectionTestId="listing-result-section"
  />
);
